<template>
    <canvas ref="chart" height="400px" width="400px"></canvas>
</template>
<script>
import Chart from 'chart.js'

export default {
    props: ["data"],
    mounted() {
        let ctx = this.$refs["chart"];

        let chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: this.data.labels,
                datasets: [{
                    label: 'Monto invertido',
                    data: this.data.data,
                    backgroundColor: [
                        'rgba(47, 188, 13, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)'
                    ],
                    borderColor: [
                        'rgba(47, 188, 13, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)'
                    ],
                    borderWidth: 3,
                    fill: false
                }]
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }]
                }
            }
        });
    }    
}
</script>
